import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import LOGO_BACON_B64 from '../utils/logoBacon';

/*const API = 'https://bacmt.com.ar';*/
const API = 'http://192.168.2.25:3000';

const EVENTOS_OCULTOS = [9, 12];
const NAVY = [16, 36, 71]; // navy Bacon para los PDF

// Rol de un evento dentro de un proceso
const infoEvento = (cod) => {
    cod = Number(cod);
    if ([14, 15, 16, 17].includes(cod)) return { cat: 'CM',  rol: 'inicio' };
    if (cod === 2)                       return { cat: 'CM',  rol: 'fin' };
    if (cod === 18)                      return { cat: 'CP',  rol: 'inicio' };
    if ([3, 4, 5, 6].includes(cod))      return { cat: 'CP',  rol: 'fin' };
    if (cod === 19)                      return { cat: 'CMo', rol: 'inicio' };
    if ([7, 8].includes(cod))            return { cat: 'CMo', rol: 'fin' };
    if (cod === 13)                      return { cat: null,  rol: 'cancela' };
    return { cat: null, rol: 'suelto' };
};

// Agrupa registros en procesos (inicio+fin) y eventos sueltos
const agruparProcesos = (registrosNewestFirst) => {
    const cronologico = [...registrosNewestFirst].reverse();
    const grupos = [];
    const abiertos = {};
    cronologico.forEach(r => {
        const info = infoEvento(r.codigo_evento);
        if (info.rol === 'inicio') {
            const g = { tipo: 'proceso', cat: info.cat, rows: [r] };
            grupos.push(g); abiertos[info.cat] = g;
        } else if (info.rol === 'fin') {
            const g = abiertos[info.cat];
            if (g) { g.rows.push(r); delete abiertos[info.cat]; }
            else { grupos.push({ tipo: 'proceso', cat: info.cat, rows: [r] }); }
        } else if (info.rol === 'cancela') {
            const claves = Object.keys(abiertos);
            if (claves.length) {
                let ultimaClave = null, ultimoIdx = -1;
                claves.forEach(k => { const idx = grupos.indexOf(abiertos[k]); if (idx > ultimoIdx) { ultimoIdx = idx; ultimaClave = k; } });
                abiertos[ultimaClave].rows.push(r); delete abiertos[ultimaClave];
            } else { grupos.push({ tipo: 'suelto', rows: [r] }); }
        } else { grupos.push({ tipo: 'suelto', rows: [r] }); }
    });
    return [...grupos].reverse().map(g => ({ ...g, rows: [...g.rows].reverse() }));
};

// Nombre legible de un proceso según su código de inicio
const nombreProceso = (cod) => {
    cod = Number(cod);
    if (cod === 14) return 'Marcación Sestamibi';
    if (cod === 15) return 'Marcación Neurobac';
    if (cod === 16) return 'Marcación Osteobac';
    if (cod === 17) return 'Marcación personalizada';
    if (cod === 18) return 'Test de pureza';
    if (cod === 19) return 'Test de Molibdeno';
    return 'Proceso';
};

// Resultado legible de un evento de fin
const resultadoFin = (cod) => {
    cod = Number(cod);
    if (cod === 2) return 'OK';
    if (cod === 5) return 'Pureza > 90%';
    if (cod === 6) return 'Pureza < 90%';
    if (cod === 3) return 'Baja actividad';
    if (cod === 4) return 'Saturación';
    if (cod === 7) return 'Bajo conteo Mo';
    if (cod === 8) return 'Mucho conteo Mo';
    return '';
};

// Categoría y resultado de cada evento
const META_EVENTO = {
    1:  { desc: 'Equipo encendido',                  cat: 'Sistema',   resultado: '' },
    2:  { desc: 'Fin de marcación',                  cat: 'Marcación', resultado: 'OK' },
    3:  { desc: 'Fin pureza - Baja actividad',       cat: 'Pureza',    resultado: 'Mal' },
    4:  { desc: 'Fin pureza - Saturación',           cat: 'Pureza',    resultado: 'Mal' },
    5:  { desc: 'Fin pureza - Mayor al 90%',         cat: 'Pureza',    resultado: 'OK' },
    6:  { desc: 'Fin pureza - Menor al 90%',         cat: 'Pureza',    resultado: 'Mal' },
    7:  { desc: 'Fin moli - Bajo conteo',            cat: 'Molibdeno', resultado: 'OK' },
    8:  { desc: 'Fin moli - Mucho conteo',           cat: 'Molibdeno', resultado: 'Mal' },
    10: { desc: 'Falla del horno',                   cat: 'Error',     resultado: 'Mal' },
    11: { desc: 'Alto fondo',                        cat: 'Alarma',    resultado: '' },
    13: { desc: 'Proceso cancelado',                 cat: 'Sistema',   resultado: 'Cancelado' },
    14: { desc: 'Inicio marcación Sestamibi',        cat: 'Marcación', resultado: '' },
    15: { desc: 'Inicio marcación Neurobac',         cat: 'Marcación', resultado: '' },
    16: { desc: 'Inicio marcación Osteobac',         cat: 'Marcación', resultado: '' },
    17: { desc: 'Inicio marcación personalizado',    cat: 'Marcación', resultado: '' },
    18: { desc: 'Inicio test de pureza',             cat: 'Pureza',    resultado: '' },
    19: { desc: 'Inicio test de Molibdeno',          cat: 'Molibdeno', resultado: '' },
};

const fechaISO = (f) => {
    const d = new Date(f);
    const p = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
};

const descargarXLSX = (filas, nombreHoja, nombreArchivo) => {
    const ws = XLSX.utils.json_to_sheet(filas);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, nombreHoja);
    XLSX.writeFile(wb, `${nombreArchivo}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

const descargarCSV = (filas, nombreArchivo) => {
    const ws = XLSX.utils.json_to_sheet(filas);
    const csv = XLSX.utils.sheet_to_csv(ws);
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${nombreArchivo}_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
};

// Encabezado branded para los PDF con logo de Bacon. Devuelve la Y donde sigue el contenido.
const headerPDF = (doc, titulo, contexto) => {
    const w = doc.internal.pageSize.getWidth();

    // Barra navy de fondo
    doc.setFillColor(...NAVY);
    doc.rect(0, 0, w, 30, 'F');

    // Logo a la izquierda (dentro de la barra)
    try { doc.addImage(LOGO_BACON_B64, 'JPEG', 6, 3, 24, 24); } catch (e) { /* si falla el logo, sigue sin él */ }

    // Título del sistema
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.text('BAC MT 2.0', 36, 13);

    // Subtítulo (nombre del reporte)
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text(titulo, 36, 21);

    // "Laboratorios Bacon" a la derecha
    doc.setFontSize(9);
    doc.setFont(undefined, 'bold');
    doc.text('Laboratorios Bacon', w - 14, 12, { align: 'right' });

    // Fecha de generación
    doc.setFontSize(7.5);
    doc.setFont(undefined, 'normal');
    doc.setTextColor(200, 210, 230);
    doc.text(`Generado: ${new Date().toLocaleString()}`, w - 14, 19, { align: 'right' });

    // Línea de contexto (filtros aplicados) debajo de la barra
    doc.setTextColor(90, 90, 90);
    doc.setFontSize(8.5);
    doc.text(contexto, 14, 38);

    return 44;
};

function Reportes() {
    const [registros, setRegistros] = useState([]);
    const [equipos, setEquipos] = useState([]);
    const [empresaSel, setEmpresaSel] = useState('todas');
    const [equipoSel, setEquipoSel] = useState('todos');
    const [desde, setDesde] = useState('');
    const [hasta, setHasta] = useState('');
    const [error, setError] = useState('');

    const traerEquipos = useCallback(async () => {
        const token = localStorage.getItem('token');
        try {
            const res = await axios.get(`${API}/api/mis-equipos`, { headers: { Authorization: `Bearer ${token}` } });
            setEquipos(res.data);
        } catch (err) { console.error('Error cargando equipos', err); }
    }, []);

    const traerDatos = useCallback(async () => {
        const token = localStorage.getItem('token');
        try {
            const res = await axios.get(`${API}/api/datos-medicos`, { headers: { Authorization: `Bearer ${token}` } });
            setRegistros(res.data);
            setError('');
        } catch (err) { setError('Error al cargar los datos. Verificá tu sesión.'); }
    }, []);

    useEffect(() => { traerEquipos(); traerDatos(); }, [traerEquipos, traerDatos]);

    const empresas = [...new Map(
        equipos.filter(e => e.empresa_nombre || e.empresa)
            .map(e => [String(e.empresa_id ?? e.empresa_nombre ?? e.empresa), e.empresa_nombre || e.empresa])
    ).entries()];

    const equiposFiltrados = empresaSel === 'todas'
        ? equipos
        : equipos.filter(e => String(e.empresa_id ?? e.empresa_nombre ?? e.empresa) === empresaSel);

    const infoEquipo = (num) => {
        const eq = equipos.find(e => e.num_interno === num);
        return {
            serie: eq?.serie || eq?.descripcion || num,
            empresa: eq?.empresa_nombre || eq?.empresa || '',
        };
    };

    const filtrar = () => {
        let regs = registros;
        if (empresaSel !== 'todas') {
            const set = new Set(equiposFiltrados.map(e => e.num_interno));
            regs = regs.filter(r => set.has(r.dispositivo_id));
        }
        if (equipoSel !== 'todos') regs = regs.filter(r => r.dispositivo_id === equipoSel);
        if (desde) regs = regs.filter(r => new Date(r.fecha) >= new Date(desde));
        if (hasta) regs = regs.filter(r => new Date(r.fecha) <= new Date(hasta + 'T23:59:59'));
        return regs.filter(r => !EVENTOS_OCULTOS.includes(Number(r.codigo_evento)));
    };

    const textoContexto = () => {
        const emp = empresaSel === 'todas' ? 'Todas las empresas' : (empresas.find(([id]) => id === empresaSel)?.[1] || empresaSel);
        const eqp = equipoSel === 'todos' ? 'Todos los equipos' : infoEquipo(equipoSel).serie;
        const rango = desde || hasta ? `${desde || '...'} a ${hasta || '...'}` : 'Todo el período';
        return `Empresa: ${emp}   |   Equipo: ${eqp}   |   Período: ${rango}`;
    };

    // ---------- DATA HELPERS ----------
    const dataBaseEventos = (regs) => regs.map(r => {
        const m = META_EVENTO[Number(r.codigo_evento)] || { desc: `Código ${r.codigo_evento}`, cat: 'Otro', resultado: '' };
        const eq = infoEquipo(r.dispositivo_id);
        const d = new Date(r.fecha);
        return {
            id: r.id, num_interno: r.dispositivo_id, serie: eq.serie, empresa: eq.empresa,
            codigo_evento: r.codigo_evento, categoria: m.cat, descripcion: m.desc,
            resultado: m.resultado, resultado_ok: m.resultado === 'OK' ? 1 : (m.resultado === 'Mal' ? 0 : ''),
            temp_set: r.temp_set ?? '', time_set: r.time_set ?? '', tiempo_real: r.tiempo_real ? 1 : 0,
            fecha: fechaISO(r.fecha), anio: d.getFullYear(), mes: d.getMonth() + 1, dia: d.getDate(), hora: d.getHours(),
        };
    });

    const dataResumenTipo = (regs) => {
        const cuenta = {};
        regs.forEach(r => {
            const cat = META_EVENTO[Number(r.codigo_evento)]?.cat || 'Otro';
            cuenta[cat] = (cuenta[cat] || 0) + 1;
        });
        return Object.entries(cuenta).map(([categoria, cantidad]) => ({ categoria, cantidad }));
    };

    const dataCalidad = (regs) => {
        const porEq = {};
        regs.forEach(r => {
            const cod = Number(r.codigo_evento); const num = r.dispositivo_id;
            if (!porEq[num]) porEq[num] = { purOk: 0, purTot: 0, molOk: 0, molTot: 0 };
            if ([3, 4, 5, 6].includes(cod)) { porEq[num].purTot++; if (cod === 5) porEq[num].purOk++; }
            if ([7, 8].includes(cod)) { porEq[num].molTot++; if (cod === 7) porEq[num].molOk++; }
        });
        return Object.entries(porEq).map(([num, v]) => {
            const eq = infoEquipo(num);
            return {
                num_interno: num, serie: eq.serie, empresa: eq.empresa,
                pureza_total: v.purTot, pureza_ok: v.purOk, pureza_ok_pct: v.purTot ? Math.round((v.purOk / v.purTot) * 100) : '',
                moli_total: v.molTot, moli_ok: v.molOk, moli_ok_pct: v.molTot ? Math.round((v.molOk / v.molTot) * 100) : '',
            };
        });
    };

    const dataConfiabilidad = (regs) => {
        const porEq = {};
        regs.forEach(r => {
            const cod = Number(r.codigo_evento); const num = r.dispositivo_id;
            if (!porEq[num]) porEq[num] = { horno: 0, altoFondo: 0, cancelados: 0 };
            if (cod === 10) porEq[num].horno++;
            if (cod === 11) porEq[num].altoFondo++;
            if (cod === 13) porEq[num].cancelados++;
        });
        return Object.entries(porEq).map(([num, v]) => {
            const eq = infoEquipo(num);
            return {
                num_interno: num, serie: eq.serie, empresa: eq.empresa,
                fallas_horno: v.horno, alto_fondo: v.altoFondo, procesos_cancelados: v.cancelados,
                total_incidencias: v.horno + v.altoFondo + v.cancelados,
            };
        });
    };

    // ---------- BASE DE EVENTOS (Excel / CSV) ----------
    const exportarBase = (formato) => {
        const regs = filtrar();
        if (regs.length === 0) { setError('No hay registros para los filtros elegidos.'); return; }
        setError('');
        const filas = dataBaseEventos(regs);
        if (formato === 'csv') descargarCSV(filas, 'bacmt_eventos');
        else descargarXLSX(filas, 'Eventos', 'bacmt_eventos');
    };

    // ---------- PDFs ----------
    const pdfResumenEjecutivo = (regs) => {
        const doc = new jsPDF();
        let y = headerPDF(doc, 'Resumen ejecutivo de actividad', textoContexto());
        const totales = dataResumenTipo(regs);
        const totalEventos = regs.length;
        doc.setTextColor(...NAVY);
        doc.setFontSize(11); doc.setFont(undefined, 'bold');
        doc.text(`Total de eventos: ${totalEventos}`, 14, y); y += 6;
        doc.setFont(undefined, 'normal');
        autoTable(doc, {
            startY: y,
            head: [['Categoría', 'Cantidad', '% del total']],
            body: totales.map(t => [t.categoria, t.cantidad, totalEventos ? `${Math.round(t.cantidad / totalEventos * 100)}%` : '0%']),
            styles: { fontSize: 9 }, headStyles: { fillColor: NAVY },
        });
        const porEq = {};
        regs.forEach(r => { const n = r.dispositivo_id; porEq[n] = (porEq[n] || 0) + 1; });
        autoTable(doc, {
            startY: doc.lastAutoTable.finalY + 8,
            head: [['Equipo', 'Empresa', 'Eventos']],
            body: Object.entries(porEq).map(([num, c]) => { const e = infoEquipo(num); return [e.serie, e.empresa, c]; }),
            styles: { fontSize: 9 }, headStyles: { fillColor: NAVY },
        });
        doc.save(`bacmt_resumen_ejecutivo_${new Date().toISOString().slice(0, 10)}.pdf`);
    };

    const pdfDetalle = (regs) => {
        const doc = new jsPDF({ orientation: 'landscape' });
        const y = headerPDF(doc, 'Detalle de eventos', textoContexto());

        // Agrupar los registros en procesos (igual que el Dashboard)
        const grupos = agruparProcesos(regs);
        const hh = (f) => new Date(f).toLocaleTimeString([], { hour:'2-digit', minute:'2-digit', second:'2-digit' });

        const filas = grupos.map(g => {
            if (g.tipo === 'proceso') {
                const inicioRow = g.rows.find(r => [14,15,16,17,18,19].includes(Number(r.codigo_evento)));
                const finRow = g.rows.find(r => [2,3,4,5,6,7,8].includes(Number(r.codigo_evento)));
                const cancelRow = g.rows.find(r => Number(r.codigo_evento) === 13);
                const ref = inicioRow || finRow || g.rows[0];
                const eq = infoEquipo(ref.dispositivo_id);

                const nombre = inicioRow ? nombreProceso(inicioRow.codigo_evento) : 'Proceso';
                let resultado = cancelRow ? 'Cancelado' : (finRow ? resultadoFin(finRow.codigo_evento) : 'En curso...');
                const datos = finRow && Number(finRow.codigo_evento) === 2
                    ? `${finRow.temp_set}°C / ${finRow.time_set}min` : '—';
                const inicio = inicioRow ? hh(inicioRow.fecha) : '—';
                const fin = finRow ? hh(finRow.fecha) : (cancelRow ? hh(cancelRow.fecha) : '');
                const horario = fin ? `${inicio} → ${fin}` : inicio;
                const fecha = new Date(ref.fecha).toLocaleDateString();

                return [eq.serie, nombre, resultado, datos, `${fecha} ${horario}`];
            } else {
                // Evento suelto (alto fondo, error, encendido, etc.)
                const r = g.rows[0];
                const m = META_EVENTO[Number(r.codigo_evento)] || { desc: `Código ${r.codigo_evento}`, cat: 'Otro', resultado: '' };
                const eq = infoEquipo(r.dispositivo_id);
                const reps = Number(r.repeticiones) || 1;
                const desc = reps > 1 ? `${m.desc} (${reps} veces)` : m.desc;
                return [eq.serie, desc, m.resultado || '—', '—', new Date(r.fecha).toLocaleString()];
            }
        });

        autoTable(doc, {
            startY: y,
            head: [['Equipo', 'Evento / Proceso', 'Resultado', 'Datos', 'Fecha/Hora']],
            body: filas,
            styles: { fontSize: 8 },
            headStyles: { fillColor: NAVY },
            didParseCell: (h) => {
                if (h.section === 'body' && h.column.index === 2) {
                    const val = String(h.cell.raw);
                    if (['OK', 'Pureza > 90%', 'Bajo conteo Mo'].includes(val)) {
                        h.cell.styles.textColor = [16, 150, 100];
                        h.cell.styles.fontStyle = 'bold';
                    } else if (['Cancelado', 'Pureza < 90%', 'Baja actividad', 'Saturación', 'Mucho conteo Mo', 'Mal'].includes(val)) {
                        h.cell.styles.textColor = [200, 40, 50];
                        h.cell.styles.fontStyle = 'bold';
                    } else if (val === 'En curso...') {
                        h.cell.styles.textColor = [200, 160, 20];
                    }
                }
            },
        });
        doc.save(`bacmt_detalle_eventos_${new Date().toISOString().slice(0, 10)}.pdf`);
    };

    const pdfCalidad = (regs) => {
        const doc = new jsPDF();
        const y = headerPDF(doc, 'Reporte de calidad por equipo', textoContexto());
        const data = dataCalidad(regs);
        autoTable(doc, {
            startY: y,
            head: [['Equipo', 'Empresa', 'Pureza OK', 'Pureza tot.', '% Pureza', 'Moli OK', 'Moli tot.', '% Moli']],
            body: data.map(d => [d.serie, d.empresa, d.pureza_ok, d.pureza_total, d.pureza_ok_pct !== '' ? d.pureza_ok_pct + '%' : '—', d.moli_ok, d.moli_total, d.moli_ok_pct !== '' ? d.moli_ok_pct + '%' : '—']),
            styles: { fontSize: 8.5 }, headStyles: { fillColor: NAVY },
        });
        doc.save(`bacmt_calidad_${new Date().toISOString().slice(0, 10)}.pdf`);
    };

    const pdfIncidencias = (regs) => {
        const doc = new jsPDF();
        const y = headerPDF(doc, 'Reporte de incidencias por equipo', textoContexto());
        const data = dataConfiabilidad(regs);
        autoTable(doc, {
            startY: y,
            head: [['Equipo', 'Empresa', 'Fallas horno', 'Alto fondo', 'Cancelados', 'Total']],
            body: data.map(d => [d.serie, d.empresa, d.fallas_horno, d.alto_fondo, d.procesos_cancelados, d.total_incidencias]),
            styles: { fontSize: 9 }, headStyles: { fillColor: NAVY },
            didParseCell: (h) => {
                if (h.section === 'body' && h.column.index === 5 && Number(h.cell.raw) > 0) {
                    h.cell.styles.textColor = [200, 40, 50];
                    h.cell.styles.fontStyle = 'bold';
                }
            },
        });
        doc.save(`bacmt_incidencias_${new Date().toISOString().slice(0, 10)}.pdf`);
    };

    const generarPDF = (tipo) => {
        const regs = filtrar();
        if (regs.length === 0) { setError('No hay registros para los filtros elegidos.'); return; }
        setError('');
        switch (tipo) {
            case 'ejecutivo':   pdfResumenEjecutivo(regs); break;
            case 'detalle':     pdfDetalle(regs); break;
            case 'calidad':     pdfCalidad(regs); break;
            case 'incidencias': pdfIncidencias(regs); break;
            default: break;
        }
    };

    const regsActuales = filtrar();
    const sinDatos = regsActuales.length === 0;

    // Los 5 informes, en una sola grilla pareja.
    const informes = [
        {
            tipo: 'base', icono: '▦', color: 'excel',
            titulo: 'Base de eventos',
            detalle: 'Tabla plana con una fila por evento (categoría, resultado, fecha desglosada). Para analizar en Power BI o Excel.',
            botones: 'excel-csv',
        },
        {
            tipo: 'ejecutivo', icono: '▤', color: 'pdf',
            titulo: 'Resumen ejecutivo',
            detalle: 'Totales generales, desglose por categoría y por equipo. El reporte presentable para mostrar la actividad del período.',
            botones: 'pdf',
        },
        {
            tipo: 'detalle', icono: '▤', color: 'pdf',
            titulo: 'Detalle de eventos',
            detalle: 'Listado completo filtrado, evento por evento, con resultado y datos de marcación. Para auditoría y respaldo.',
            botones: 'pdf',
        },
        {
            tipo: 'calidad', icono: '▤', color: 'pdf',
            titulo: 'Calidad por equipo',
            detalle: '% de pureza y molibdeno OK por equipo. El KPI de calidad de las marcaciones.',
            botones: 'pdf',
        },
        {
            tipo: 'incidencias', icono: '▤', color: 'pdf',
            titulo: 'Incidencias',
            detalle: 'Fallas de horno, alto fondo y procesos cancelados por equipo. Para seguimiento de problemas.',
            botones: 'pdf',
        },
    ];

    return (
        <div style={styles.page}>
            <Navbar />
            <div style={styles.contenido}>

                <div style={styles.header}>
                    <p style={styles.headerSub}>EXPORTACIÓN</p>
                    <h2 style={styles.headerTitulo}>Reportes</h2>
                    <p style={styles.headerDesc}>
                        Elegí empresa, equipo y período; los filtros se aplican a todos los informes.
                    </p>
                </div>

                {/* FILTROS */}
                <div style={styles.filtros}>
                    {empresas.length > 0 && (
                        <div style={styles.filtroGrupo}>
                            <label style={styles.filtroLabel}>EMPRESA</label>
                            <select style={styles.select} value={empresaSel} onChange={(e) => { setEmpresaSel(e.target.value); setEquipoSel('todos'); }}>
                                <option value="todas">Todas</option>
                                {empresas.map(([id, nombre]) => <option key={id} value={id}>{nombre}</option>)}
                            </select>
                        </div>
                    )}
                    <div style={styles.filtroGrupo}>
                        <label style={styles.filtroLabel}>EQUIPO</label>
                        <select style={styles.select} value={equipoSel} onChange={(e) => setEquipoSel(e.target.value)}>
                            <option value="todos">Todos</option>
                            {equiposFiltrados.map(eq => <option key={eq.id} value={eq.num_interno}>{eq.serie || eq.descripcion || eq.num_interno}</option>)}
                        </select>
                    </div>
                    <div style={styles.filtroGrupo}>
                        <label style={styles.filtroLabel}>DESDE</label>
                        <input type="date" style={styles.select} value={desde} onChange={(e) => setDesde(e.target.value)} />
                    </div>
                    <div style={styles.filtroGrupo}>
                        <label style={styles.filtroLabel}>HASTA</label>
                        <input type="date" style={styles.select} value={hasta} onChange={(e) => setHasta(e.target.value)} />
                    </div>
                    <div style={styles.filtroResumen}>
                        <span style={styles.filtroResumenNum}>{regsActuales.length}</span>
                        <span style={styles.filtroResumenTxt}>eventos en el filtro</span>
                    </div>
                </div>

                {error && <div style={styles.errorBox}>⚠ {error}</div>}

                {/* GRILLA DE 5 INFORMES */}
                <div style={styles.grid}>
                    {informes.map(rep => (
                        <div key={rep.tipo} style={styles.repCard}>
                            <div style={rep.color === 'excel' ? styles.repIcon : styles.repIconPDF}>{rep.icono}</div>
                            <h3 style={styles.repTitulo}>{rep.titulo}</h3>
                            <p style={styles.repDetalle}>{rep.detalle}</p>
                            <div style={styles.repBtns}>
                                {rep.botones === 'excel-csv' ? (
                                    <>
                                        <button style={styles.btnExcel} onClick={() => exportarBase('xlsx')} disabled={sinDatos}>↓ Excel</button>
                                        <button style={styles.btnCSV} onClick={() => exportarBase('csv')} disabled={sinDatos}>↓ CSV</button>
                                    </>
                                ) : (
                                    <button style={styles.btnPDF} onClick={() => generarPDF(rep.tipo)} disabled={sinDatos}>↓ PDF</button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                <p style={styles.nota}>
                    La <strong>Base de eventos</strong> (Excel/CSV) es la tabla de datos para analizar en Power BI o Excel.
                    Los otros cuatro son PDF presentables, con encabezado que incluye empresa, equipo y período del filtro aplicado.
                </p>
            </div>
        </div>
    );
}

const styles = {
    page: { minHeight: '100vh' },
    contenido: { padding: '32px 36px', maxWidth: '1400px', margin: '0 auto' },
    header: { marginBottom: '24px' },
    headerSub: { fontSize: '0.7rem', color: 'var(--accent)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '6px' },
    headerTitulo: { fontSize: '1.5rem', fontWeight: '600', color: 'var(--text-primary)', letterSpacing: '-0.02em', marginBottom: '8px' },
    headerDesc: { fontSize: '0.875rem', color: 'var(--text-muted)', maxWidth: '620px', lineHeight: 1.5 },

    filtros: { display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'flex-end', backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '18px 20px', marginBottom: '24px' },
    filtroGrupo: { display: 'flex', flexDirection: 'column', gap: '6px' },
    filtroLabel: { fontSize: '0.65rem', color: 'var(--text-muted)', letterSpacing: '0.1em', textTransform: 'uppercase' },
    select: { backgroundColor: 'var(--bg-surface)', border: '1px solid var(--border)', color: 'var(--text-primary)', padding: '8px 12px', borderRadius: '8px', fontSize: '0.85rem', fontFamily: 'IBM Plex Sans, sans-serif', minWidth: '160px', colorScheme: 'dark' },
    filtroResumen: { marginLeft: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' },
    filtroResumenNum: { fontSize: '1.6rem', fontWeight: '700', color: 'var(--accent)', fontFamily: 'IBM Plex Mono, monospace', lineHeight: 1 },
    filtroResumenTxt: { fontSize: '0.72rem', color: 'var(--text-muted)' },

    errorBox: { backgroundColor: 'rgba(240,77,94,0.1)', border: '1px solid rgba(240,77,94,0.25)', color: 'var(--danger)', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', fontSize: '0.875rem' },

    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' },
    repCard: { backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '22px', display: 'flex', flexDirection: 'column' },
    repIcon: { width: '40px', height: '40px', borderRadius: '10px', marginBottom: '14px', backgroundColor: 'var(--accent-glow)', border: '1px solid var(--accent)', color: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem' },
    repIconPDF: { width: '40px', height: '40px', borderRadius: '10px', marginBottom: '14px', backgroundColor: 'rgba(240,77,94,0.1)', border: '1px solid rgba(240,77,94,0.3)', color: 'var(--danger)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem' },
    repTitulo: { fontSize: '1.05rem', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '8px' },
    repDetalle: { fontSize: '0.8rem', color: 'var(--text-muted)', lineHeight: 1.45, marginBottom: '18px', flexGrow: 1 },
    repBtns: { display: 'flex', gap: '8px' },
    btnExcel: { flex: 1, backgroundColor: 'rgba(16,196,138,0.1)', border: '1px solid rgba(16,196,138,0.25)', color: 'var(--success)', padding: '8px 14px', borderRadius: '8px', cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '500' },
    btnCSV: { flex: 1, backgroundColor: 'rgba(47,127,255,0.1)', border: '1px solid rgba(47,127,255,0.25)', color: 'var(--accent)', padding: '8px 14px', borderRadius: '8px', cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '500' },
    btnPDF: { flex: 1, backgroundColor: 'rgba(240,77,94,0.1)', border: '1px solid rgba(240,77,94,0.25)', color: 'var(--danger)', padding: '8px 14px', borderRadius: '8px', cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'IBM Plex Sans, sans-serif', fontWeight: '500' },

    nota: { marginTop: '22px', fontSize: '0.8rem', color: 'var(--text-muted)', lineHeight: 1.5, backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '10px', padding: '14px 18px' },
};

export default Reportes;